import { testMapping } from "utilFunctions/Constants/testMapping";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import PropTypes from "prop-types";
import moment from "moment";
export const getOverAllTableData = (testData) => {
  let overAllTableData = [];
  testData.map((item, i) => {
    overAllTableData.push({
      ...item,
      index: i,
      test: item.name.split ? item.name.split("#")[0] : item.name,
      name: item.name.split ? item.name.split("#")[0] : item.name,
      percentage: Math.round(item?.percentage),
      time:
        item?.time && item?.time != null
          ? moment(item.time).format("DD-MMM-YYYY")
          : "-",
    });
  });
  return overAllTableData;
};
export const getOverallPerformance = (testData) => {
  const overallSortedData = sortDateArrByKey(testData, "time");
  let scoreOverall = [];
  for (let i = 0; i < overallSortedData.length; i++) {
    scoreOverall[i] = {
      examType: "test",
      testName:
        overallSortedData[i]?.name.replace("#", "-") +
        "#" +
        convertTime(overallSortedData[i]?.time, "D MMM"),
      test: overallSortedData[i]?.name.split
        ? overallSortedData[i]?.name.split("#")[0]
        : overallSortedData[i]?.name,
      examDate: convertTime(overallSortedData[i]?.time, "D MMM'YY"),
      percentage: Math.round(overallSortedData[i]?.percentage || ""),
      score: Math.round(overallSortedData[i]?.score || ""),
      total: Math.round(overallSortedData[i]?.total || ""),
      subjects: Object.keys(overallSortedData[i]?.subjects || ""),
      ...flatJSON(overallSortedData[i]?.subjects || ""),
    };
  }
  return scoreOverall;
};
export const flatJSON = (obj = {}, res = {}, newKey = "") => {
  for (let key in obj) {
    if (typeof obj[key] !== "object") {
      res[newKey + key] = obj[key];
    } else {
      flatJSON(obj[key], res, `${newKey}${key}.`);
    }
  }
  return res;
};
export const FilterArrayForTest = (array = [], originalArray) => {
  const newOrgnlArray = [...array, ...originalArray];
  const uniqArray = Array.from(
    new Set(newOrgnlArray.map((item) => item.test.replace(/#\d+/, "")))
  );
  let newArray = [];
  if (uniqArray && Array.isArray(uniqArray) && uniqArray.length > 0) {
    uniqArray.map((element) => {
      if (element) {
        newArray.push({
          label: element,
          value: element,
          test: element,
        });
      }
    });
  }
  return newArray;
};

export const makeSelectArray = (array) => {
  let newSelectArray = [{ label: "Test", value: "percentage" }];
  if (array && Array.isArray(array) && array.length > 0) {
    array.forEach((element) => {
      newSelectArray.push({ label: element, value: element });
    });
  }
  return newSelectArray;
};

export const filterDataForTestType = (arr1, arr2) => {
  let res = [];
  res = arr1.filter((el) => {
    return arr2.find((element) => {
      return element.value === el.test;
    });
  });
  return res;
};

export const getMinOverallData = (testData) => {
  let minimumValue = 0;
  for (let i = 0; i < testData?.length; i++) {
    minimumValue = Math.min(
      minimumValue,
      Math.min(
        isNaN(testData[i]["term"]) ? 0 : testData[i]["term"],
        Math.min(
          isNaN(testData[i]["fort"]) ? 0 : testData[i]["fort"],
          isNaN(testData[i]["aiats"]) ? 0 : testData[i]["aiats"]
        )
      )
    );
  }
  return minimumValue;
};

function onlynumber(l) {
  return l.filter((x) => typeof x === "number");
}

export const getMinValueFromData = (testData) => {
  let testdataArray = [];
  testData.map((item) => {
    const newArray = Object.values(item);
    testdataArray.push(...newArray);
  });
  return Math.min(...onlynumber(testdataArray));
};

export const sortDateArrByKey = (arr, sortByDateKey) => {
  return (
    arr &&
    arr.sort((currValue, nextValue) => {
      var currDate = new Date(currValue[sortByDateKey]);
      var nextDate = new Date(nextValue[sortByDateKey]);
      return nextDate - currDate;
    })
  );
};

export const getBarTickValues = (minValue, maxValue) => {
  const yAxisTicks = [];
  minValue = Math.floor((minValue - 10) / 10) * 10;
  const interval = Math.ceil((maxValue - minValue) / 5);
  for (let i = 0; i < 6; i++) {
    yAxisTicks.push(minValue);

    minValue = minValue + interval;
  }
  if (yAxisTicks[5] > 100) {
    yAxisTicks[5] = 100;
  }
  yAxisTicks.reverse();
  return yAxisTicks;
};
export const CustomTick = ({ x, value, date, index, testData, ...rest }) => {
  const label = getShortFormOfTestName(testData[index].examType);
  console.log(rest);
  if (value) {
    return (
      <foreignObject className="w-12 h-8" x={x - 18} y={253}>
        <div className="fixed w-12 h-6 flex flex-col items-center text-white">
          <div className="text-xs font-bold leading-none text-black">
            {label}
          </div>
          <div className="text-[#a1aeb7] text-[10px] font-bold">
            {testData[index][date]}
          </div>
        </div>
      </foreignObject>
    );
  } else {
    return <></>;
  }
};
CustomTick.propTypes = {
  x: PropTypes.any,
  value: PropTypes.any,
  date: PropTypes.any,
  index: PropTypes.any,
  testData: PropTypes.any,
};

export const GetBarShape = (
  x,
  y,
  width,
  height,
  radius,
  fill,
  fillOpacity,
  stroke
) => {
  let tl;
  let tr;
  let bl;
  let br;
  if (radius && Array.isArray(radius)) {
    [tl, tr, bl, br] = radius;
  }

  const d = `M${x},${y + tl}
		a${tl},${tl} 0 0 1 ${tl},${-tl}
		h${width - tl - tr}
		a${tr},${tr} 0 0 1 ${tr},${tr}
		v${height - tr - br}
		a${br},${br} 0 0 1 ${-br},${br}
		h${bl + (br - width)}
		a${bl},${bl} 0 0 1 ${-bl},${-bl}
		z`;
  return <path d={d} fill={fill} fillOpacity={fillOpacity} stroke={stroke} />;
};

GetBarShape.propTypes = {
  x: PropTypes.any,
  y: PropTypes.any,
  width: PropTypes.any,
  height: PropTypes.any,
  radius: PropTypes.array,
  fill: PropTypes.any,
  fillOpacity: PropTypes.any,
  stroke: PropTypes.any,
};

export const getShortFormOfTestName = (testType) => testMapping[testType];
